import { render, staticRenderFns } from "./DriverRoutePanel.vue?vue&type=template&id=cf35c27e&scoped=true"
import script from "./DriverRoutePanel.vue?vue&type=script&lang=js"
export * from "./DriverRoutePanel.vue?vue&type=script&lang=js"
import style0 from "./DriverRoutePanel.vue?vue&type=style&index=0&id=cf35c27e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf35c27e",
  null
  
)

export default component.exports